import React from 'react';
import './MissionStatementSection.css';
import EmbedYouTubeVideo from '../../common/EmbedYouTubeVideo/EmbedYouTubeVideo';
import { Row, Col } from 'antd';

const MissionStatementSection = (props) => {
   return (
      <div className="MissionStatementSection--container">
        <div className="MissionStatementSection--headline text-inverse">
          <h1 className="text-inverse"><span className="MissionStatementSection--text-background">Help People Thrive!</span></h1>
          
       </div>
       <div className="MissionStatementSection--body-text text-inverse">
         <p>
          <span className="MissionStatementSection--text-background">Our Mission: Utilizing Our Unique Real Time Touch Technology to Help People Thrive!</span>
         </p>
         {/* <img className="MissionStatementSection--img-main" src="http://via.placeholder.com/600x350/f44242/fff?text=Video+Mission+Statement" /> */}

         {/* <EmbedYouTubeVideo video="vKLN7btr8m8" type="short" width="800" /> */}
        
         <EmbedYouTubeVideo video="dHhTkEQCorc" type="short" width="800" /><br/>

            <div className="VideosPage--collapse-container" style={{width:1300, margin:'0 auto'}}>
 
 <div className="gutter-example">

   <Row>
     <Col className="gutter-row" sm={24} md={8}>
       <div className="gutter-box" style={{marginRight:2}}>
       <div class="card">
         <div class="header">
           <EmbedYouTubeVideo width="400" type="short" video="gYSoNX6aDbw" title=""/>
         </div>

         <div class="container">
           <p>Decentralizing Clinical Trials</p>
         </div>
       </div>                    
       
       </div>
     </Col>
     <Col className="gutter-row" sm={24} md={8}>
       <div className="gutter-box" style={{marginRight:2}}>
         <div class="card">
           <div class="header">
            <EmbedYouTubeVideo width="400" type="short" video="VXkrDXk5rmo" title=""/>
           </div>

           <div class="container">
             <p>Reducing Readmissions</p>
           </div>
         </div>     

       </div>
     </Col>
     <Col className="gutter-row" sm={24} md={8}>
       <div className="gutter-box">
         <div class="card">
           <div class="header">
             <EmbedYouTubeVideo width="400" type="short" video="OegPSItsfwM" title=""/>
           </div>

           <div class="container">
             <p>Reducing Opioid Dependences</p>
           </div>
         </div>     

       </div>
     </Col>
   </Row>
</div>
</div>

        {/* <EmbedYouTubeVideo video="VXkrDXk5rmo" type="short" width="500" />

        <EmbedYouTubeVideo video="dHhTkEQCorc" type="short" width="500" />

        <EmbedYouTubeVideo video="OegPSItsfwM" type="short" width="500" />

        <EmbedYouTubeVideo video="gYSoNX6aDbw" type="short" width="500" /> */}

         

       </div>
      </div>
    )
 }

 export default MissionStatementSection;
  


// WEBPACK FOOTER //
// ./src/containers/MissionStatementSection/MissionStatementSection.js